import { defaultFetcherOptions } from '../../../../ui/utils/defaultFetcherOptions';
import { useEffect } from 'react';
import useSWR from 'swr';
import { useShiftParticipantActions } from './useShiftParticipantActions';
export const shiftParticipantsFetchKey = 'shiftParticipants';
export const usePastApprovedShiftParticipant = (params) => {
    var _a, _b, _c, _d, _e;
    const { handleAddHours: handleAddHoursAction, handleDeleteHours: handleDeleteHoursAction, handleApproveHours: handleApproveHoursAction, fetchPastApprovedParticipations, } = useShiftParticipantActions();
    const { data: pastApprovedParticipations, isLoading, mutate, } = useSWR([shiftParticipantsFetchKey, params], ([, params]) => {
        return fetchPastApprovedParticipations(params).then((response) => response);
    }, defaultFetcherOptions);
    useEffect(() => {
        if (isLoading) {
            return;
        }
        mutate();
    }, [params.appliedFilters, params.orderBy, isLoading, mutate]);
    const handleAddHours = (addHoursParams) => {
        if (!pastApprovedParticipations) {
            return;
        }
        return handleAddHoursAction(addHoursParams);
    };
    const handleDeleteHours = (deleteHoursParams) => {
        if (!pastApprovedParticipations) {
            return;
        }
        return handleDeleteHoursAction(deleteHoursParams);
    };
    const handleApproveHours = (approveHoursParams) => {
        if (!pastApprovedParticipations) {
            return;
        }
        return handleApproveHoursAction(approveHoursParams);
    };
    return {
        pastApprovedParticipations: {
            shiftsMissingHours: (_a = pastApprovedParticipations === null || pastApprovedParticipations === void 0 ? void 0 : pastApprovedParticipations.shiftsMissingHours) !== null && _a !== void 0 ? _a : 0,
            shiftParticipants: {
                total: (_c = (_b = pastApprovedParticipations === null || pastApprovedParticipations === void 0 ? void 0 : pastApprovedParticipations.shiftParticipants) === null || _b === void 0 ? void 0 : _b.total) !== null && _c !== void 0 ? _c : 0,
                rows: (_e = (_d = pastApprovedParticipations === null || pastApprovedParticipations === void 0 ? void 0 : pastApprovedParticipations.shiftParticipants) === null || _d === void 0 ? void 0 : _d.rows) !== null && _e !== void 0 ? _e : [],
            },
        },
        handleAddHours,
        handleApproveHours,
        handleDeleteHours,
        isLoading,
        fetchParticipants: mutate,
    };
};
